import React from 'react';

import { FileVersionModel } from '../../../../../../typings/api/skymap/rest/v1/.common';
import { sortFileVersions } from '../../../../utils/models/file-version';

export const useFileVersions = (fileVersions: FileVersionModel[]) => {
  const sortedVersions = React.useMemo(
    () => sortFileVersions(fileVersions),
    [fileVersions],
  ) as FileVersionModel[];

  const getVersionNumber = (fileVersionId: string) =>
    sortedVersions.findIndex((x) => x.id === fileVersionId) + 1;

  const lastVersion = sortedVersions[sortedVersions.length - 1];

  return {
    getVersionNumber,
    lastVersion,
  };
};
